import Vue from '../../lib/vue2.js';
import Datepicker from 'vuejs-datepicker';
import axios from 'axios';
import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';
import './customSelect.js';
import JQuery from 'jquery'
import multiformHelper from './helper'


// multiform-general
Vue.component('multiformGeneral', {
    template: '#multiformGeneral',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'general',
                checkin: '',
                checkout: '',
                numberOfPeople: '',
                numberOfRooms: '',
                first_name: '',
                familyName: '',
                streetNumber: '',
                city: '',
                postCode: '',
                country: '',
                telephone: '',
                email: '',
                questions: '',
                grecaptcha: ''
            },
            formError: {
                type: false,
                checkin: false,
                checkout: false,
                numberOfPeople: false,
                numberOfRooms: false,
                first_name: false,
                familyName: false,
                streetNumber: false,
                city: false,
                postCode: false,
                country: false,
                telephone: false,
                email: false,
                questions: false,
                grecaptcha: false
            },
        };
    },
    mounted: function() {
        var self = this;
        $('.contact-page-form .nvsSelNumberOfPeople').nivasSelect({
            onSelect: function(value, text, model){
                self.formData.numberOfPeople = value;
            }   
        });
        $('.contact-page-form .nvsSelNumberOfRooms').nivasSelect({
            onSelect: function(value, text, model){
                self.formData.numberOfRooms = value;
            }   
        });
        $('.contact-page-form .nvsSelCountry').nivasSelect({
            onSelect: function(value, text, model){
                self.formData.country = value;
            }   
        });
    },
    created: function () {
        console.log('created multiformGeneral component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited multiformWellnessFitness", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {

                this.formError = validationObj.formError;

                if(validationObj.formErrorMsg)
                {
                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 10000);
                }
                else if(validationObj.formSuccessMsg)
                {
                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });
        },
    }
});

// multiform-wellness-fitness
Vue.component('multiformWellnessFitness', {
    template: '#multiformWellnessFitness',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'wellness_fitness',
                first_name: '',
                last_name: '',
                email: '',
                //phone: '',
                //date: '',
                //time: '',
                grecaptcha: '',
                msg: '',
            },
            formError: {
                type: false,
                first_name: false,
                last_name: false,
                email: false,
                //phone: false,
                //date: false,
                grecaptcha: false,
                time: false,
                msg: false,
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created multiformWellnessFitness component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited multiformWellnessFitness", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {

                if(validationObj.formErrorMsg)
                {
                    this.formError = validationObj.formError;

                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 5000);
                }
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });
        },
    }
});

// multiform-main-restaurant
Vue.component('multiformMainRestaurant', {
    template: '#multiformMainRestaurant',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'main-restaurant',
                first_name: '',
                last_name: '',
                email: '',
                msg: '',
                
            },
            formError: {
                type: false,
                first_name: false,
                last_name: false,
                email: false,
                msg: false,
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created multiformMainRestaurant component');
    },
    methods: {
        submit: function() {
            var component = this;
            
            console.log("submited multiformMainRestaurant", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {

                if(validationObj.formErrorMsg)
                {
                    this.formError = validationObj.formError;

                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 5000);
                }
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });

        },
    }
});

// multiform-restaurant-beef
Vue.component('multiformRestaurantBeef', {
    template: '#multiformRestaurantBeef',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'restaurant-beef',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                date: '',
                time: '',
                msg: '',
            },
            formError: {
                type: false,
                first_name: false,
                last_name: false,
                email: false,
                phone: false,
                date: false,
                time: false,
                msg: false,
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created multiformRestaurantBeef component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited multiformRestaurantBeef", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {


                if(validationObj.formErrorMsg)
                {
                    this.formError = validationObj.formError;

                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 5000);
                }
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });

        },
    }
});

// multiform-spa
Vue.component('multiformSpa', {
    template: '#multiformSpa',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'spa',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                date: '',
                time: '',
                msg: '',
            },
            formError: {
                type: false,
                first_name: false,
                last_name: false,
                email: false,
                phone: false,
                date: false,
                time: false,
                msg: false,
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created multiformSpa component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited multiformSpa", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {

    
                if(validationObj.formErrorMsg)
                {
                    this.formError = validationObj.formError;
                    
                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 5000);
                }
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });

        },
    }
})


// multiform-concierge
Vue.component('multiformConcierge', {
    template: '#multiformConcierge',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'concierge',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                date: '',
                time: '',
                msg: '',
            },
            formError: {
                type: false,
                first_name: false,
                last_name: false,
                email: false,
                phone: false,
                date: false,
                time: false,
                msg: false,
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created multiformConcierge component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited multiformConcierge", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {


                if(validationObj.formErrorMsg)
                {
                    this.formError = validationObj.formError;
                    
                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 5000);
                }
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });

        },
    }
});

// multiform-reception
Vue.component('multiformReception', {
    template: '#multiformReception',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                type: 'reception',
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                date: '',
                time: '',
                msg: '',
            },
            formError: {
                type: false,
                first_name: false,
                last_name: false,
                email: false,
                phone: false,
                date: false,
                time: false,
                msg: false,
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created multiformReception component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited multiformReception", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;
            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xinquiry', this.formData, (validationObj) => {


                if(validationObj.formErrorMsg)
                {
                    this.formError = validationObj.formError;
                    
                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 5000);
                } 
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.inquiryForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });
        },
    }
});







// Multiform switch
Vue.component('multiformRoot', {
    template: '#multiformRoot',
    components: {
    },
    watch: {
    },
    data: function () {
        return {
            type: ''
        };
    },
    mounted: function() {
    },
    created: function () {
        console.log('created multiformRoot component');
    },
    methods: {
    }
});






